import { Add } from '@mui/icons-material';
import { Button, Typography } from '@mui/material';
import { FC } from 'react';

import { useNavigateDialogForm } from '../../../components/formikDialogForm/dialogForm.hook';
import { VisibleIfAdmin } from '../../auth/components/VisibleIfAdmin';

import { ProjektTable } from './ProjektTable';

export const ProjektListScreen: FC = () => {
  const navigateDialog = useNavigateDialogForm('projekt', 'create');

  return (
    <div>
      <Typography variant="h4" sx={{ mb: 3 }}>
        Projekte
      </Typography>
      <VisibleIfAdmin>
        <Button
          variant="contained"
          color="secondary"
          startIcon={<Add />}
          onClick={() => navigateDialog()}
          sx={{ mb: 3 }}
        >
          Neues Projekt
        </Button>
      </VisibleIfAdmin>
      <ProjektTable />
    </div>
  );
};
